export const QUERY_PARAMS: string = "QUERY_PARAMS";
export const COUNTRY_CODE: string = "countryCode";
